export default __webpack_public_path__ + "static/1070-67e4d6e00109f679d822398df5e8b9aa.gif";